/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: In8OlLBJG380

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import * as pp from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicButton.module.css"; // plasmic-import: In8OlLBJG380/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

createPlasmicElementProxy;

export type PlasmicButton__VariantMembers = {
  isDisabled: "isDisabled";
  size: "small" | "medium" | "large";
  color: "primary" | "sky" | "white" | "cta" | "gray";
};
export type PlasmicButton__VariantsArgs = {
  isDisabled?: SingleBooleanChoiceArg<"isDisabled">;
  size?: SingleChoiceArg<"small" | "medium" | "large">;
  color?: SingleChoiceArg<"primary" | "sky" | "white" | "cta" | "gray">;
};
type VariantPropType = keyof PlasmicButton__VariantsArgs;
export const PlasmicButton__VariantProps = new Array<VariantPropType>(
  "isDisabled",
  "size",
  "color"
);

export type PlasmicButton__ArgsType = {
  link?: string;
  submitsForm?: boolean;
  target?: boolean;
  "aria-label"?: string;
  id?: string;
  startIcon?: React.ReactNode;
  children?: React.ReactNode;
  endIcon?: React.ReactNode;
};
type ArgPropType = keyof PlasmicButton__ArgsType;
export const PlasmicButton__ArgProps = new Array<ArgPropType>(
  "link",
  "submitsForm",
  "target",
  "aria-label",
  "id",
  "startIcon",
  "children",
  "endIcon"
);

export type PlasmicButton__OverridesType = {
  root?: Flex__<"button">;
  startIconContainer?: Flex__<"div">;
  contentContainer?: Flex__<"div">;
  endIconContainer?: Flex__<"div">;
};

export interface DefaultButtonProps extends pp.BaseButtonProps {
  submitsForm?: boolean;
  target?: boolean;
  "aria-label"?: string;
  id?: string;
  size?: SingleChoiceArg<"small" | "medium" | "large">;
  color?: SingleChoiceArg<"primary" | "sky" | "white" | "cta" | "gray">;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicButton__RenderFunc(props: {
  variants: PlasmicButton__VariantsArgs;
  args: PlasmicButton__ArgsType;
  overrides: PlasmicButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isDisabled",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isDisabled
      },
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.size
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      aria-label={(() => {
        try {
          return $props["aria-label"];
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcolor_cta]: hasVariant($state, "color", "cta"),
          [sty.rootcolor_cta_isDisabled]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "cta"),
          [sty.rootcolor_cta_isDisabled_size_medium]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "cta"),
          [sty.rootcolor_cta_isDisabled_size_small]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "small") &&
            hasVariant($state, "color", "cta"),
          [sty.rootcolor_cta_size_large]:
            hasVariant($state, "size", "large") &&
            hasVariant($state, "color", "cta"),
          [sty.rootcolor_cta_size_large_isDisabled]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "large") &&
            hasVariant($state, "color", "cta"),
          [sty.rootcolor_cta_size_medium]:
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "cta"),
          [sty.rootcolor_cta_size_small]:
            hasVariant($state, "size", "small") &&
            hasVariant($state, "color", "cta"),
          [sty.rootcolor_gray]: hasVariant($state, "color", "gray"),
          [sty.rootcolor_gray_size_medium]:
            hasVariant($state, "color", "gray") &&
            hasVariant($state, "size", "medium"),
          [sty.rootcolor_primary]: hasVariant($state, "color", "primary"),
          [sty.rootcolor_sky]: hasVariant($state, "color", "sky"),
          [sty.rootcolor_white]: hasVariant($state, "color", "white"),
          [sty.rootcolor_white_size_medium]:
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "white"),
          [sty.rootisDisabled]: hasVariant($state, "isDisabled", "isDisabled"),
          [sty.rootisDisabled_color_gray]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "gray"),
          [sty.rootisDisabled_color_gray_size_medium]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "gray"),
          [sty.rootisDisabled_color_primary]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "primary"),
          [sty.rootisDisabled_color_sky]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "sky"),
          [sty.rootisDisabled_color_white]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "white"),
          [sty.rootisDisabled_color_white_size_medium]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "white"),
          [sty.rootisDisabled_size_medium]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "medium"),
          [sty.rootisDisabled_size_medium_color_primary]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "primary"),
          [sty.rootisDisabled_size_medium_color_sky]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "sky"),
          [sty.rootisDisabled_size_small_color_gray]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "gray") &&
            hasVariant($state, "size", "small"),
          [sty.rootisDisabled_size_small_color_primary]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "primary") &&
            hasVariant($state, "size", "small"),
          [sty.rootisDisabled_size_small_color_sky]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "sky") &&
            hasVariant($state, "size", "small"),
          [sty.rootisDisabled_size_small_color_white]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "small") &&
            hasVariant($state, "color", "white"),
          [sty.rootsize_large]: hasVariant($state, "size", "large"),
          [sty.rootsize_large_color_gray]:
            hasVariant($state, "color", "gray") &&
            hasVariant($state, "size", "large"),
          [sty.rootsize_large_color_primary]:
            hasVariant($state, "size", "large") &&
            hasVariant($state, "color", "primary"),
          [sty.rootsize_large_color_sky]:
            hasVariant($state, "size", "large") &&
            hasVariant($state, "color", "sky"),
          [sty.rootsize_large_color_white]:
            hasVariant($state, "size", "large") &&
            hasVariant($state, "color", "white"),
          [sty.rootsize_large_isDisabled]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "large"),
          [sty.rootsize_large_isDisabled_color_gray]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "gray") &&
            hasVariant($state, "size", "large"),
          [sty.rootsize_large_isDisabled_color_primary]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "primary") &&
            hasVariant($state, "size", "large"),
          [sty.rootsize_large_isDisabled_color_sky]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "color", "sky") &&
            hasVariant($state, "size", "large"),
          [sty.rootsize_large_isDisabled_color_white]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "large") &&
            hasVariant($state, "color", "white"),
          [sty.rootsize_medium]: hasVariant($state, "size", "medium"),
          [sty.rootsize_medium_color_primary]:
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "primary"),
          [sty.rootsize_medium_color_sky]:
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "sky"),
          [sty.rootsize_small]: hasVariant($state, "size", "small"),
          [sty.rootsize_small_color_gray]:
            hasVariant($state, "size", "small") &&
            hasVariant($state, "color", "gray"),
          [sty.rootsize_small_color_primary]:
            hasVariant($state, "size", "small") &&
            hasVariant($state, "color", "primary"),
          [sty.rootsize_small_color_sky]:
            hasVariant($state, "size", "small") &&
            hasVariant($state, "color", "sky"),
          [sty.rootsize_small_color_white]:
            hasVariant($state, "size", "small") &&
            hasVariant($state, "color", "white")
        }
      )}
      id={args.id}
      title={(() => {
        try {
          return $props["aria-label"];
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      {false ? (
        <div
          data-plasmic-name={"startIconContainer"}
          data-plasmic-override={overrides.startIconContainer}
          className={classNames(projectcss.all, sty.startIconContainer, {
            [sty.startIconContainercolor_primary]: hasVariant(
              $state,
              "color",
              "primary"
            )
          })}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <svg
                className={classNames(projectcss.all, sty.svg___4Kh3L)}
                role={"img"}
              />
            ),

            value: args.startIcon,
            className: classNames(sty.slotTargetStartIcon, {
              [sty.slotTargetStartIconcolor_primary]: hasVariant(
                $state,
                "color",
                "primary"
              ),
              [sty.slotTargetStartIconcolor_white]: hasVariant(
                $state,
                "color",
                "white"
              )
            })
          })}
        </div>
      ) : null}
      <div
        data-plasmic-name={"contentContainer"}
        data-plasmic-override={overrides.contentContainer}
        className={classNames(projectcss.all, sty.contentContainer, {
          [sty.contentContainercolor_cta]: hasVariant($state, "color", "cta"),
          [sty.contentContainercolor_cta_isDisabled_size_medium]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "cta"),
          [sty.contentContainercolor_gray]: hasVariant($state, "color", "gray"),
          [sty.contentContainerisDisabled]: hasVariant(
            $state,
            "isDisabled",
            "isDisabled"
          ),
          [sty.contentContainerisDisabled_color_gray_size_medium]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "gray"),
          [sty.contentContainerisDisabled_color_white_size_medium]:
            hasVariant($state, "isDisabled", "isDisabled") &&
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "color", "white"),
          [sty.contentContainerisDisabled_size_medium]:
            hasVariant($state, "size", "medium") &&
            hasVariant($state, "isDisabled", "isDisabled"),
          [sty.contentContainersize_medium]: hasVariant(
            $state,
            "size",
            "medium"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: "Learn more",
          value: args.children,
          className: classNames(sty.slotTargetChildren, {
            [sty.slotTargetChildrencolor_cta]: hasVariant(
              $state,
              "color",
              "cta"
            ),
            [sty.slotTargetChildrencolor_cta_isDisabled]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "color", "cta"),
            [sty.slotTargetChildrencolor_cta_isDisabled_size_medium]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "size", "medium") &&
              hasVariant($state, "color", "cta"),
            [sty.slotTargetChildrencolor_cta_isDisabled_size_small]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "size", "small") &&
              hasVariant($state, "color", "cta"),
            [sty.slotTargetChildrencolor_cta_size_large_isDisabled]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "size", "large") &&
              hasVariant($state, "color", "cta"),
            [sty.slotTargetChildrencolor_gray]: hasVariant(
              $state,
              "color",
              "gray"
            ),
            [sty.slotTargetChildrencolor_primary]: hasVariant(
              $state,
              "color",
              "primary"
            ),
            [sty.slotTargetChildrencolor_sky]: hasVariant(
              $state,
              "color",
              "sky"
            ),
            [sty.slotTargetChildrencolor_white]: hasVariant(
              $state,
              "color",
              "white"
            ),
            [sty.slotTargetChildrenisDisabled]: hasVariant(
              $state,
              "isDisabled",
              "isDisabled"
            ),
            [sty.slotTargetChildrenisDisabled_color_gray]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "color", "gray"),
            [sty.slotTargetChildrenisDisabled_color_primary]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "color", "primary"),
            [sty.slotTargetChildrenisDisabled_color_sky]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "color", "sky"),
            [sty.slotTargetChildrenisDisabled_color_white]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "color", "white"),
            [sty.slotTargetChildrenisDisabled_color_white_size_medium]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "size", "medium") &&
              hasVariant($state, "color", "white"),
            [sty.slotTargetChildrenisDisabled_size_small_color_gray]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "size", "small") &&
              hasVariant($state, "color", "gray"),
            [sty.slotTargetChildrenisDisabled_size_small_color_sky]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "color", "sky") &&
              hasVariant($state, "size", "small"),
            [sty.slotTargetChildrenisDisabled_size_small_color_white]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "size", "small") &&
              hasVariant($state, "color", "white"),
            [sty.slotTargetChildrensize_large]: hasVariant(
              $state,
              "size",
              "large"
            ),
            [sty.slotTargetChildrensize_large_isDisabled_color_white]:
              hasVariant($state, "isDisabled", "isDisabled") &&
              hasVariant($state, "size", "large") &&
              hasVariant($state, "color", "white"),
            [sty.slotTargetChildrensize_medium]: hasVariant(
              $state,
              "size",
              "medium"
            ),
            [sty.slotTargetChildrensize_small]: hasVariant(
              $state,
              "size",
              "small"
            )
          })
        })}
      </div>
      {false ? (
        <div
          data-plasmic-name={"endIconContainer"}
          data-plasmic-override={overrides.endIconContainer}
          className={classNames(projectcss.all, sty.endIconContainer, {
            [sty.endIconContainercolor_white]: hasVariant(
              $state,
              "color",
              "white"
            )
          })}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <IconIcon
                className={classNames(projectcss.all, sty.svg__hvE2J)}
                role={"img"}
              />
            ),

            value: args.endIcon,
            className: classNames(sty.slotTargetEndIcon, {
              [sty.slotTargetEndIconcolor_white]: hasVariant(
                $state,
                "color",
                "white"
              )
            })
          })}
        </div>
      ) : null}
    </button>
  ) as React.ReactElement | null;
}

function useBehavior<P extends pp.PlumeButtonProps>(
  props: P,
  ref: pp.ButtonRef
) {
  const b = pp.useButton<P, typeof PlasmicButton>(
    PlasmicButton,
    props,
    {
      showStartIconVariant: {
        group: "showStartIcon",
        variant: "showStartIcon"
      },
      showEndIconVariant: { group: "showEndIcon", variant: "showEndIcon" },
      isDisabledVariant: { group: "isDisabled", variant: "isDisabled" },
      contentSlot: "children",
      startIconSlot: "startIcon",
      endIconSlot: "endIcon",
      root: "root"
    },
    ref
  );
  if (b.plasmicProps.overrides.root.as === "a") {
    b.plasmicProps.overrides.root.as = PlasmicLink__;
    b.plasmicProps.overrides.root.props.component = Link;
    b.plasmicProps.overrides.root.props.platform = "nextjs";
  }
  return b;
}

const PlasmicDescendants = {
  root: ["root", "startIconContainer", "contentContainer", "endIconContainer"],
  startIconContainer: ["startIconContainer"],
  contentContainer: ["contentContainer"],
  endIconContainer: ["endIconContainer"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  startIconContainer: "div";
  contentContainer: "div";
  endIconContainer: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicButton__VariantsArgs;
    args?: PlasmicButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicButton__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicButton__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButton__ArgProps,
          internalVariantPropNames: PlasmicButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicButton";
  } else {
    func.displayName = `PlasmicButton.${nodeName}`;
  }
  return func;
}

export const PlasmicButton = Object.assign(
  // Top-level PlasmicButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    startIconContainer: makeNodeComponent("startIconContainer"),
    contentContainer: makeNodeComponent("contentContainer"),
    endIconContainer: makeNodeComponent("endIconContainer"),

    // Metadata about props expected for PlasmicButton
    internalVariantProps: PlasmicButton__VariantProps,
    internalArgProps: PlasmicButton__ArgProps,

    useBehavior
  }
);

export default PlasmicButton;
/* prettier-ignore-end */
